module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-panel weui-panel_access"
  }, [(_vm.header && _vm.header.title) ? _c('div', {
    staticClass: "weui-panel__hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header.title)
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-click-header')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__bd"
  }, [_c('div', {
    staticClass: "vux-card-content"
  }, [_vm._t("content")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__ft"
  }, [(_vm.footer && _vm.footer.title) ? _c('a', {
    staticClass: "weui-cell weui-cell_access weui-cell_link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.onClickFooter
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e1abdd4"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/card/index.vue
// module id = 542
// module chunks = 4